{
    "deckActionCardDraw": {
        "cards": [
            {
                "name": "Starter_Tending"
            },
            {
                "name": "Starter_Fishing_2"
            },
            {
                "name": "Starter_Chopping_2"
            },
            {
                "name": "Starter_ZenithOrders"
            }
        ]
    },
    "deckActionCardDiscard": {
        "cards": []
    },
    "deckActionDrawLeft": {
        "cards": [
            {
                "name": "Season3Action_AntiAntiSocial"
            },
            {
                "name": "Season3Action_Woodsman"
            },
            {
                "name": "Season3Action_FreshFarmer"
            },
            {
                "name": "Season2Action_SecretMineFisher"
            },
            {
                "name": "Season2Action_ExpertFisher"
            },
            {
                "name": "Season2Action_FarmForester"
            },
            {
                "name": "Season2Action_ProjectDabbler"
            },
            {
                "name": "Season1Action_NoviceCollector"
            },
            {
                "name": "Season1Action_ShinyCollector"
            },
            {
                "name": "Season1Action_CaveFisher"
            },
            {
                "name": "Season1Action_FarmClearer"
            }
        ]
    },
    "deckActionDrawRight": {
        "cards": [
            {
                "name": "Season3Action_MarketDelver"
            },
            {
                "name": "Season3Action_Kingfisher"
            },
            {
                "name": "Season3Action_WoodsExplorer"
            },
            {
                "name": "Season2Action_WoodCleaner"
            },
            {
                "name": "Season2Action_Excavator"
            },
            {
                "name": "Season2Action_AmateurFarmer"
            },
            {
                "name": "Season2Action_LumberjackFisher"
            },
            {
                "name": "Season1Action_FarmMiner"
            },
            {
                "name": "Season1Action_WoodScrapper"
            },
            {
                "name": "Season1Action_Gatherer"
            },
            {
                "name": "Season1Action_NoviceFisher"
            }
        ]
    },
    "deckActionCardActive": {
        "cards": [
            {
                "name": "Starter_Mining"
            },
            {
                "name": "Starter_Mining_2"
            },
            {
                "name": "Starter_Fishing"
            },
            {
                "name": "Starter_Tending_2"
            },
            {
                "name": "Starter_Chopping"
            }
        ]
    },
    "objectiveOne": {
        "name": "Objective_S1_Loner"
    },
    "objectiveTwo": {
        "name": "Objective_S2_Explorer"
    },
    "objectiveThree": {
        "name": "Objective_S3_Assembler"
    },
    "randomSeed": {
        "seed": 97
    }
}